const validationUtils = {
    validateForm(state, returnFieldErrorFlags) {
        let errorMessagesArr = [];
        let fieldErrorFlags = {};

        if (!state.validationRules) {
            return null;
        }

        state.validationRules.map(fieldValidation => {
            validationUtils.applyMultipleFieldValidation(state, fieldValidation, errorMessagesArr, fieldErrorFlags);

            const { inputId } = fieldValidation;
            const value = state.data[inputId] || '';

            if (typeof value === 'undefined') {
                const errorMessage = `Data model does not match schema. ${inputId} is missing`;
                validationUtils.addErrMessage(errorMessagesArr, errorMessage);
                fieldErrorFlags[inputId] = errorMessage;
                return false;
            }

            const fieldValue = value.toString().trim();

            validationUtils.applyRequiredValidation(fieldValue, fieldValidation, errorMessagesArr, fieldErrorFlags);
            validationUtils.applyRegExValidation(fieldValue, fieldValidation, errorMessagesArr, fieldErrorFlags);

            return true;
        });

        if (!errorMessagesArr.length) {
            return null;
        }

        const errorMessage = errorMessagesArr.join('\n');

        if (returnFieldErrorFlags)
            return { errorMessage, fieldErrorFlags };

        return errorMessage;
    },

    applyRequiredValidation(value, validation, errArr, fieldErrorFlags) {
        const result = (validation.rule === 'required' && !value);

        if (result) {
            const errorMessage = validation.message;
            validationUtils.addErrMessage(errArr, errorMessage);
            fieldErrorFlags[validation.inputId] = errorMessage;
        }
    },

    applyRegExValidation(value, validation, errArr, fieldErrorFlags) {
        if (validation.rule === 'required' || (value === '' && !validation.require) ) {
            return;
        }

        const re = new RegExp(validation.rule);

        const result = re.test(value.toString());

        if (!result) {
            const errorMessage = validation.message;
            validationUtils.addErrMessage(errArr, errorMessage);
            fieldErrorFlags[validation.inputId] = errorMessage;
        }
    },

    applyMultipleFieldValidation(state, validation, errArr, fieldErrorFlags) {
        if (validation.rule === "multiple") {
            const hasError = validation.fields.some(field => {
                const value = state.data[field.inputId] || '';
                return !value || value === "";
            });

            if (hasError) {
                validation.fields.forEach(field => {
                    const errorMessage = validation.message;
                    validationUtils.addErrMessage(errArr, errorMessage);
                    fieldErrorFlags[field.inputId] = errorMessage;
                });
            }
        }
    },

    addErrMessage: (errArr, errMessage) => {
        errArr.push(errMessage);
    }
};

export default validationUtils;
